import { useAppStorePopup } from '../../contexts';
import AppStorePopUp from './AppStorePopUp';

export const AppStorePopupManager: React.FC = () => {
  const { isOpen, closeAppStorePopup } = useAppStorePopup();

  return (
    <AppStorePopUp 
      open={isOpen} 
      onOpenChange={closeAppStorePopup}
    />
  );
};
